import ExposedApiKeys from "../../../../contents/docs/_snippets/exposed-api-keys.mdx";
import * as React from 'react';
export default {
  ExposedApiKeys,
  React
};